import React, { useEffect } from 'react';
import { useLanguage } from '../../../hooks/useLanguage';
import { aside as frAside } from '../../../locales/fr/aside';
import { aside as arAside } from '../../../locales/ar/aside';
import { aside as esAside } from '../../../locales/es/aside';
import useMyAppStore from '../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const Users = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.users);
  }, [lang, t.routes.users, setPageTitle]);

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        {lang === 'ar' ? 'المستخدمين' : 'Utilisateurs'}
      </h2>
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'اسم المستخدم' : 'Nom d\'utilisateur'}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'الدور' : 'Rôle'}
              </th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                {lang === 'ar' ? 'تاريخ الإنشاء' : 'Date de création'}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            <tr>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" colSpan="3">
                {lang === 'ar' ? 'لا يوجد مستخدمين' : 'Aucun utilisateur'}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users; 